/**
 * @ngdoc controller
 * @param ecourse Resolved ecourse from route
 * @param RegistrationService
 * @param LiveService Handles the live alert display
 * @constructor
 * @param EcourseFactory
 * @param $state
 * @param environment
 * @param ViewsService
 * @param Alerts
 * @param Ecourses
 */
export default function ecourseController(ecourse, RegistrationService, LiveService, EcourseFactory, $state, environment, ViewsService, Alerts, Ecourses) {
  'ngInject';

  this.ecourse = ecourse;
  RegistrationService.ecourse = ecourse;
  //TODO -> LOW -> Google/Facebook Analytics
  LiveService.init(ecourse);

  this.url = $state.href();
  this.caption = `Bethel.tv E-Course ${this.ecourse.title}. ${this.url}`;

  this.meems = this.ecourse.social.map((element) => {
    return {imageUrl: element, caption: this.caption};
  });

  if (this.ecourse.userData) {
    const progress = this.ecourse.userData.progress.filter(item => !!item.id);
    const progressData = Object.assign({}, this.ecourse.userData, { progress });
    Object.assign(this.ecourse, { progressData });
  }

  this.nextLiveSegment = EcourseFactory.nextLiveSegment(ecourse);

  this.registrationUrl = function (state, params) {
    let url = $state.href(state, params, {absolute: true});
    return environment.name === 'Production' ? url.replace('http', 'https') : url;
  };

  this.bookmark = ()=> {
    Ecourses.bookmark(this.ecourse);
  };

  ViewsService.create('ecourse_content', this.ecourse.id);

  Alerts.synchronizeAlerts(60 * 1000, {
    type: 'ecourse_content',
    typeId: this.ecourse.id
  });
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/ecourse.controller.js
 **/